const escapeHtml = (value: string): string =>
  value.replace(/[&<>'"]/g, (character) => ({
    "&": "&amp;", "<": "&lt;", ">": "&gt;", "'": "&#39;", '"': "&quot;",
  })[character] ?? character);

export const formShell = (
  input: {
    resource: "service-type" | "live-input" | "schedule";
    id?: string;
    title: string;
    subtitle: string;
    body: string;
    create?: boolean;
    deleteLabel?: string;
  },
): string => `
  <details class="config-card${input.create ? " config-card-create" : ""}">
    <summary>
      <span><strong>${escapeHtml(input.title)}</strong><small>${escapeHtml(input.subtitle)}</small></span>
      <span class="config-disclosure">Edit</span>
    </summary>
    <form
      class="configuration-form"
      data-resource="${input.resource}"
      ${input.id ? `data-resource-id="${escapeHtml(input.id)}"` : ""}
    >
      ${input.body}
      <p class="form-message" role="status" aria-live="polite"></p>
      <div class="configuration-form-actions">
        <button class="primary-button compact" type="submit">${input.create ? "Create" : "Save changes"}</button>
        ${input.deleteLabel ? `<button class="danger-button configuration-delete-button" type="button">${escapeHtml(input.deleteLabel)}</button>` : ""}
      </div>
    </form>
  </details>
`;
